import React, { useEffect, useState, useRef } from "react";
import HeaderBar from "../components/HeaderBar";
import Sidebar from "../components/Sidebar";
import LoadingDataPage from "./LoadingDataPage";
import { useTranslation } from "react-i18next";

const REDIRECT_URL = 
  `${window.location.origin}/integrations`; 
const TOKEN_CALLBACK_URL = process.env.REACT_APP_FORTNOX_TOKEN_CALLBACK_URL;
const TOKEN_INFO_URL = process.env.REACT_APP_FORTNOX_TOKEN_INFO_URL;
const LOGIN_URL =
    `https://apps.fortnox.se/oauth-v1/auth?client_id=lMIcYjdYx4p5&redirect_uri=${REDIRECT_URL}&scope=invoice customer bookkeeping connectfile supplierinvoice costcenter supplier&state=somestate123&access_type=offline&response_type=code`;

const SystemsPage = () => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [tokenInfo, setTokenInfo] = useState(null);
  const [error, setError] = useState(null);
  const [codeUsed, setCodeUsed] = useState(false);
  const hasRunInit = useRef(false);

  useEffect(() => {
    if (hasRunInit.current) return; // bara kör init en gång
    hasRunInit.current = true;

    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get("code");

    const exchangeToken = async (authCode) => {
      try {
        const res = await fetch(TOKEN_CALLBACK_URL, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ code: authCode }),
        });

        if (!res.ok) throw new Error(t("systems.couldNotExchangeCode"));
        setCodeUsed(true);
        window.history.replaceState({}, document.title, "/systems");
      } catch (err) {
        console.error(err);
        setError(t("systems.couldNotLogInFortnox"));
      }
    };

    const checkTokenInfo = async () => {
      try {
        const res = await fetch(TOKEN_INFO_URL);
        const data = await res.json();

        console.log("Token info:", data);

        if (!data.hasToken) {
          setTokenInfo(null);
          setError(data.error || t("systems.noTokenFound"));
        } else {
          setTokenInfo(data);
        }
      } catch (err) {
        console.error(err);
        setError(t("systems.couldNotFetchTokenInfo"));
      } finally {
        setLoading(false);
      }
    };

    const init = async () => {
      if (code && !codeUsed) {
        await exchangeToken(code);
      }
      await checkTokenInfo();
    };

    init();
  }, [codeUsed, t]);

  const startFortnoxLogin = () => {
    window.location.href = LOGIN_URL;
  };

  return (
    <>
      <HeaderBar />
      <div className="flex">
        <Sidebar />
        <div className="page">
          {loading && (
            <div className="absolute inset-0 pointer-events-none">
              <LoadingDataPage title={t("entity.systems")} loading={true} />
            </div>
          )}

          {!loading && (
            <div className="page-content">
              <div className="flex flex-col gap-8">
                <h2 className="text-2xl text-black font-bold">{t("nav.systems")}</h2>

                <div className="rounded-md shadow-md p-4">
                  <h3 className="font-semibold mb-2">Fortnox</h3>

                   <button
                        onClick={startFortnoxLogin}
                        className="btn btn-primary text-white rounded-md px-4 py-2 mb-8"
                      >
                        {tokenInfo && tokenInfo.hasToken 
                        ? t("systems.refreshToken") : t("common.connect")
                        }
                      </button>

                  {tokenInfo && tokenInfo.hasToken ? (
                    <>
                      <p className="text-green-700">
                        {t("systems.accessTokenValidUntil")}{" "}
                        <strong>
                          {new Date(tokenInfo.accessTokenExpiresAt).toLocaleString()}
                        </strong>
                      </p>
                      <p className="text-green-700">
                        {t("systems.refreshTokenValidUntil")}{" "}
                            {new Date(Date.now() + tokenInfo.refreshTokenValidForDays * 24 * 60 * 60 * 1000).toLocaleDateString()}
{/*                         <strong>{Math.floor(tokenInfo.refreshTokenValidForDays)} days</strong>.
 */}                      </p>
                    </>
                  ) : (
                    <>
                      <p className="text-mute-600 mb-2">
                        {t("systems.noFortnoxConnection")}
                      </p>
                     
                      {error && <p className="text-red-600 mt-2">{error}</p>}
                    </>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default SystemsPage;
